import { cn } from "@/lib/utils";

type TitleProps = { 
  children: React.ReactNode;
  className?: string;
};

export function Title({ children, className }: TitleProps) {
  return (
    <h1 className={cn("text-4xl tracking-tight ml-[-2px]", className)}>
      {children}
    </h1>
  );
}